import { ARRAY_DEFAULT, FUNC_DEFAULT } from 'constants';
import { useEffect, useState } from 'react';

const useCountdownToAction = ({
  countdownInit = 0,
  isRun = false,
  cb = FUNC_DEFAULT,
  deps = ARRAY_DEFAULT,
  delaySec = 1,
  isLoop = false,
}) => {
  const [countdown, setCountdown] = useState(countdownInit);

  useEffect(() => {
    let timer;

    if (isRun) {
      timer = setTimeout(() => {
        setCountdown((count) => count - 1);
      }, delaySec * 1000);
    }

    if (countdown === -1) {
      const loopCallback = () => {
        if (!isLoop) return null;
        setCountdown(countdownInit);
      };
      console.log(`⭐ useCountdownToAction 👉 action ↩`);
      cb(loopCallback);
    }

    return () => {
      console.log(`⭐ useCountdownToAction 👉 cleanup ➡️ clearTimeout ↩`);
      clearTimeout(timer);
    };
  }, [countdown, ...deps]);

  return { countdown };
};

export default useCountdownToAction;
